import {app} from "./initializePixi";
import LevelView from "./LevelView";
import "./KeyboardManager";
import state from "./State";
import './GestureManager';
import * as React from 'react';
import ReactDOM from 'react-dom';
import ReactApplication from "./ReactApplication";
import './main.css';

LevelView.init();
app.stage.addChild(LevelView.el);

state.init();

const reactApplicationDOMNode = document.createElement('div');
document.body.appendChild(reactApplicationDOMNode);

ReactDOM.render(<ReactApplication />, reactApplicationDOMNode);

/*
const saveButton = document.createElement('a');
let file = new Blob(['Ciao Mondo'], { type: "text/plain;charset=utf-8" });
let url = URL.createObjectURL(file);
saveButton.href = url;
saveButton.download = 'pippo.txt';
saveButton.textContent = 'salva';
document.body.appendChild(saveButton);
*/
